import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { ChevronLink } from '@bibliocommons/base-links';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Heading from 'app/components/shared/Heading';
import BibSeries from 'app/components/bibs/shared/BibSeries';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import { SameSeriesOverlayContainer } from 'app/components/bibs/BibPage/About/SameSeries/SameSeriesOverlay';
import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import { sameSeriesShape } from 'app/shapes/bibPage';
import './SameSeries.scss';

const MAX_ITEMS_DISPLAYED = 3;

export default class SameSeries extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      overlayOpen: false
    };
    bindAll(this);
  }

  openOverlay() {
    this.setState({ overlayOpen: true });
  }

  closeOverlay() {
    this.setState({ overlayOpen: false });
  }

  render() {
    const { series, catalogBib, handleBibTitle, handleBibImage } = this.props;
    const bibs = series.get('seriesEntries');
    const totalBibs = series.get('totalSeriesEntries');
    const seriesTitle = series.get('seriesTitle');
    if (!bibs || !bibs.size) return null;
    const source = 'novelist';

    // Remove current bib from series entries
    const displayedBibs = bibs
      .filter(bib => bib.get('metadataId') !== catalogBib.get('metadataId'))
      .slice(0, MAX_ITEMS_DISPLAYED);

    return (
      <div className="cp-same-series">
        <div className="same-series-heading">
          <Heading tagName="h3" size="medium" variant>
            <FormattedMessage id="in_the_same_series" />
            {seriesTitle && `: ${seriesTitle}`}
          </Heading>
          <VendorAttributionLabel name="novelist" />
        </div>

        <BibSeries
          bibs={displayedBibs}
          source={source}
          handleBibTitle={handleBibTitle}
          handleBibImage={handleBibImage}
        />
        {totalBibs > displayedBibs.size && (
          <ChevronLink
            href="#same-series-overlay"
            dataKey="same-series-view-all-link"
            preventDefault
            handleClick={this.openOverlay}
          >
            <span aria-hidden>
              <FormattedMessage id="view_all" />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id="view_all_in_the_same_series" />
            </ScreenReaderMessage>
          </ChevronLink>
        )}
        <FullScreenOverlayContainer
          open={this.state.overlayOpen}
          handleClose={this.closeOverlay}
          overlayKey="same-series-full-screen-overlay"
          dataKey="same-series-full-screen-overlay"
        >
          {this.state.overlayOpen && <SameSeriesOverlayContainer {...this.props} />}
        </FullScreenOverlayContainer>
      </div>
    );
  }
}

SameSeries.propTypes = {
  catalogBib: catalogBibShape,
  handleBibImage: PropTypes.func,
  handleBibTitle: PropTypes.func,
  series: sameSeriesShape.isRequired
};
